import { render, staticRenderFns } from "./bindRg.vue?vue&type=template&id=5265b6bc&"
import script from "./bindRg.vue?vue&type=script&lang=ts&"
export * from "./bindRg.vue?vue&type=script&lang=ts&"
import style0 from "./bindRg.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports